import { QESAlert } from "@app/shared/qes-standards/Alert";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import { JSX } from "react";

export const cmsCreditIconToggleApply = (
    cmsCreditIsApplying: boolean,
    setCMSCreditIsApplying: (active: boolean) => void,
    cmsCreditTemplateValue: string
): JSX.Element => (
    <RoleRestricted allowedRoles={[Roles.CMS_APPLICATION_CREDIT_VIEWER]}>
        <QESCheckbox
            label={`Apply ${cmsCreditTemplateValue}% CMS Application Credit`}
            checked={cmsCreditIsApplying}
            onChange={(e) => setCMSCreditIsApplying(e.target.checked)}
            testId="cms-credit__apply-toggle"
            containerClassName="ms-3"
        />
    </RoleRestricted>
);

export const cmsCreditIconToggleChanges = (
    cmsCreditIsApplying: boolean,
    cmsCreditShowOnlyChanges: boolean,
    setCMSCreditShowOnlyChanges: (active: boolean) => void,
    cmsCreditTemplateValue: string,
    gapsFilterEnabled: boolean,
    hasCountyAndSpecialtyFilters: boolean,
): JSX.Element => (
    <RoleRestricted allowedRoles={[Roles.CMS_APPLICATION_CREDIT_VIEWER]}>
        <QESCheckbox
            label={`Show Specialties that Pass with CMS ${cmsCreditTemplateValue}% Application Credit`}
            checked={cmsCreditIsApplying && cmsCreditShowOnlyChanges && !gapsFilterEnabled}
            onChange={(e) => setCMSCreditShowOnlyChanges(e.target.checked)}
            disabled={!cmsCreditIsApplying || gapsFilterEnabled || hasCountyAndSpecialtyFilters}
            testId="cms-credit__view-only-changes-toggle"
            containerClassName="ms-3"
        />
    </RoleRestricted>
);

export const cmsCreditDataAlert = (cmsCreditTemplateValue: string): JSX.Element => (
    <QESAlert
        type="info"
        persist={true}
    >
        The following data reflects the addition of the temporary {cmsCreditTemplateValue}% CMS Application Credit. This temporary credit is only applied to Pending counties. Information about Prospect and Market networks, with regard to impact and gap filling, is unavailable when the temporary {cmsCreditTemplateValue}% CMS Application Credit toggle is applied.
    </QESAlert>
);

export const cmsCreditProvidersAlert = (cmsCreditTemplateValue: string): JSX.Element => (
    <QESAlert
        type="info"
        persist={true}
        classNames="mt-4">
        Prospect and Market providers are not viewable when the temporary {cmsCreditTemplateValue}% CMS Application Credit is applied.
    </QESAlert>
);